// Represents the number of milliseconds in a day
export const MS_IN_DAY = 24 * 60 * 60 * 1000

export const CORRESPONDENCE_TYPES = {
  WELCOME: "WELCOME",
}
